<template>
  <h1 class="ml-4">Tutorials</h1>
  <v-btn
    class="mb-4 ml-4"
    :color="buttonColor"
    @click="toggleAllTutorials"
  >
    {{ buttonText }}
  </v-btn>
  <div v-if="tutorialData" class="ml-">
    <v-expansion-panels >
      <v-expansion-panel v-for="key in orderedKeys" :key="key">
        <template v-if="tutorialData[key]">
          <v-expansion-panel-title>
            <template v-slot:default>
              <v-row no-gutters>
                <v-col cols="6" class="d-flex justify-start">
                  <v-list-item-title>
                    {{ capitalizeKey(key) }}
                  </v-list-item-title>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-fade-transition leave-absolute>
                    <span> Clique para ativar os tutoriais </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-data-table
              :headers="headers"
              :items="tutorialData[key]"
              class="elevation-1"
            >
              <template v-slot:[`item.firstAccess`]="{ item }">
                <v-chip
                  :color="item.firstAccess ? 'green-darken-2' : 'red-darken-2'"
                  label
                  variant="elevated"
                  @click.stop="alterarStatus(item)"
                >
                  {{ item.firstAccess ? 'Ativo' : 'Inativo' }}
                </v-chip>
              </template>
            </v-data-table>
          </v-expansion-panel-text>
        </template>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <p>Carregando dados do tutorial...</p>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getTutorialTelas, setTutorial, setAllTutorialsStatus } from "../../libs/getTutorials";

export default {
  name: "Tutorial",
  data: () => ({
    tutorialData: null,
    autenticado: getAuth(),
    user: null,
    orderedKeys: ['pedidosEncomendas', 'cadastro', 'controle', 'dadosCadastrais'],
    headers: [
      {
        title: 'Campo',
        align: 'start',
        key: 'value',
      },
      {
        title: 'Status',
        align: 'end',
        key: 'firstAccess',
      },
    ],
  }),
  computed: {
    hasActiveTutorials() {
      if (!this.tutorialData) {
        return false;
      }
      for (const key in this.tutorialData) {
        const category = this.tutorialData[key];
        const hasActive = category.some(item => item.firstAccess);
        if (hasActive) {
          return true;
        }
      }
      return false;
    },
    buttonText() {
      return this.hasActiveTutorials ? "Desativar todos os Tutoriais" : "Ativar todos os Tutoriais";
    },
    buttonColor() {
      return this.hasActiveTutorials ? "red" : "green-darken-2";
    }
  },
  methods: {
    capitalizeKey(key) {
      if (!key) return "";
      return key.charAt(0).toUpperCase() + key.slice(1);
    },
    async carregarDadosTutorial() {
      if (this.user) {
        const rawData = await getTutorialTelas(this.user);
        if (rawData) {
          const formattedData = {};
          for (const categoryKey in rawData) {
            if (Object.prototype.hasOwnProperty.call(rawData, categoryKey) && Array.isArray(rawData[categoryKey])) {
              formattedData[categoryKey] = rawData[categoryKey].map(item => ({
                ...item,
                category: categoryKey
              }));
            }
          }
          this.tutorialData = formattedData;
        }
      } else {
        console.log("Error - Unauthorized");
      }
    },
    async alterarStatus(item) {
      if (this.user) {
        await setTutorial(this.user, item);
        await this.carregarDadosTutorial();
      } else {
        console.log("Error - Unauthorized");
      }
    },
    async toggleAllTutorials() {
      if (this.user) {
        const newStatus = !this.hasActiveTutorials;
        await setAllTutorialsStatus(this.user, newStatus);
        await this.carregarDadosTutorial();
      } else {
        console.log("Error - Unauthorized");
      }
    }
  },
  created() {
    onAuthStateChanged(this.autenticado, async (user) => {
      if (user) {
        this.user = user;
        await this.carregarDadosTutorial();
      } else {
        this.user = null;
        console.log("Usuário deslogado.");
      }
    });
  },
};
</script>

<style scoped>
</style>